import React from "react";

const Backend = () => {
  return (
    <div className="skills__content flex flex-col gap-5">
      <h3 className="skills__title ">Backend</h3>

      <div className="skills__box">
        <div className="skills__group">
          <div className="skills__data">
            <i class="bx bxl-nodejs"></i>
            <div>
              <h3 className="skills__name">Node.js</h3>
            </div>
          </div>

          <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Nest.js</h3>
            </div>
          </div>

          <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Express</h3>
            </div>
          </div>

          <div className="skills__data">
            <i class="bx bxl-postgresql"></i>
            <div>
              <h3 className="skills__name">PostgreSQL</h3>
            </div>
          </div>

          <div className="skills__data">
            <i class="bx bxl-mongodb"></i>
            <div>
              <h3 className="skills__name">MongoDB</h3>
            </div>
          </div>
        </div>

        <div className="skills__group">
          <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Prisma</h3>
            </div>
          </div>

          <div className="skills__data">
            <i class="bx bxl-redis"></i>
            <div>
              <h3 className="skills__name">Redis</h3>
            </div>
          </div>

          <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">REST &amp; WebSocket APIs</h3>
            </div>
          </div>

          <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Socket.io</h3>
            </div>
          </div>

          <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">JWT / OAuth2</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Backend;
